import React, { useState, useCallback, useEffect } from 'react';
import { orgTypes } from '../../Constants';
import useApi from '../../api/useApi';

function ProjectUser({ handleClose, notification, action, selectedUser, refreshList }) {
  const { userId } = JSON.parse(localStorage.user).user;
  const orgId = JSON.parse(localStorage.user).organization.id;
  const assignUser = selectedUser.map((data) => {
    return {
      userId: data.id,
      role: data.role,
    };
  });

  const formModel = {
    users: assignUser,
    createdBy: userId,
  };

  const [formData, setFormData] = useState([]);
  // const [{ isLoading, isError, data }, postData] = useApi();
  const [{ isLoading, isError, data }, getProject] = useApi();
  const [state2, setAssignProject] = useApi();
  // const [state2, updateData] = useApi();

  useEffect(() => {
    getProject(`/organization/${orgId}/projects`, 'GET');
  }, [action]);

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData(data.projects);     
      refreshList();
    }
    if (isError) {
      notification('error', 'Unable to fetch project detail');
    }
  }, [isLoading, isError, data]);

  // getOrganization for update response
  // useEffect(() => {
  //   if (!state.isLoading && !state.isError && state.data) {
  //     setFormData(state.data.message);
  //   }
  // }, [state]);

  // update response
  
  const projects = (id) => {
    setAssignProject(`/project/${id}/users`, 'POST', formModel);
  };
  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data) {
      notification('success', 'Assigned user to project successfully')
      refreshList();
      handleClose();
    }
    if(state2.isError) {
      notification('error', 'Unable to assigned user to project ')
      handleClose();
    }

  }, [state2]);
  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20 px-16 text-textBlue1"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4 h-2/4 py-8 pl-10 relative mt-10 rounded-3xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-5 right-10 h-4 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-lg  m-3.5 text-textBlue1">Project</p>
        <ul className="flex flex-wrap projecTUser ">
          {formData.map((value, index) => {
            return (
              <li
                className="flex w-2/5 text-lg m-3.5 p-3.5 focus:outline-none cursor-pointer"
                onClick={() => projects(value.id)}
                key={value.id}
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              >
                {value.projectName}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default ProjectUser;
